import { render, staticRenderFns } from "./CompanyAlarmsSummary.vue?vue&type=template&id=02968f28&scoped=true&"
import script from "./CompanyAlarmsSummary.vue?vue&type=script&lang=js&"
export * from "./CompanyAlarmsSummary.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAlarmsSummary.vue?vue&type=style&index=0&id=02968f28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02968f28",
  null
  
)

export default component.exports